<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateUser)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>perm_identity</md-icon>
          </div>
          <h4 class="title">Student Profile - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-50">
              <ValidationProvider
                name="first_name"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>First Name</label>
                  <md-input v-model="first_name" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <ValidationProvider
                name="last_name"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Last Name</label>
                  <md-input v-model="last_name" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <ValidationProvider
                name="gender"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Gender</label>
                  <md-select v-model="gender" name="gender">
                    <md-option value="">Select Gender</md-option>
                    <md-option value="M">Male</md-option>
                    <md-option value="F">Female</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-small-size-100 md-size-50">
              <ValidationProvider
                name="mobile_phone"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Mobile Phone</label>
                  <md-input v-model="mobile_phone" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <ValidationProvider
                name="country"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Country</label>
                  <md-select v-model="country" name="country">
                    <md-option value="">Select Country</md-option>
                    <md-option
                      v-for="c in countries"
                      v-bind:key="c.id"
                      :value="c.id"
                      >{{ c.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <ValidationProvider
                name="email"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Email</label>
                  <md-input v-model="email" type="text" disabled> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success mt-4"
                >Update Profile</md-button
              >
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, confirmed, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userID: null,
      first_name: null,
      last_name: null,
      email: null,
      gender: null,
      mobile_phone: null,
      title: null,
      country: null,
      picture: null,
      is_active: false,
      countries: []
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    updateUser() {
      // Student user
      let role = 2;
      this.$store
        .upsertBasicUser(
          "PUT",
          this.userID,
          {
            first_name: this.first_name,
            last_name: this.last_name,
            title: this.title,
            gender: this.gender,
            mobile_phone: this.mobile_phone,
            country: this.country,
            role: this.role,
            is_active: this.is_active
          },
          role
        )
        .then(response => {
          this.$notify({
            message: "User updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.$store
      .getCountries()
      .then(response => {
        this.countries = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
  }
};
</script>
<style></style>
